import { UserProfile } from '../../../models/user-profile/user-profile';
import { UserProfileGetResponse } from './user-profile-get-response';
import { UserProfileRequest } from './user-profile-request';
export function adaptUserProfile(res: UserProfileGetResponse): UserProfile {
  return new UserProfile({
    birthday: res.birthday,
    firstName: res.first_name,
    firstNameReading: res.first_name_reading,
    lastName: res.last_name,
    lastNameReading: res.last_name_reading,
    gender: res.gender,
    optin: res.optin,
  });
}
export function adaptUserProflileRequest(req: UserProfile): UserProfileRequest {
  return {
    birthday: req.birthday,
    first_name: req.firstName,
    first_name_reading: req.firstNameReading,
    last_name: req.lastName,
    last_name_reading: req.lastNameReading,
    gender: req.gender,
    optin: req.optin,
  };
}
